import { Controller } from "@hotwired/stimulus"

// Generic add/remove-row list for a plain array form field (e.g.
// Plan#advantages) — no per-row indexing needed since the field is a bare
// array column, not accepts_nested_attributes_for, so every row just
// shares the same `name="...[]"` and Rails collects them in DOM order.
export default class extends Controller {
  static targets = [ "list", "template" ]

  add() {
    this.listTarget.appendChild(this.templateTarget.content.cloneNode(true))
  }

  remove(event) {
    event.currentTarget.closest(".dynamic-list-item")?.remove()
  }
}
